// extracted by mini-css-extract-plugin
module.exports = {"container":"Guard_container__y3JNC"};